import { VHeaders } from '@/models/pagedlistmodel';

export function getVantiTransactionListHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'vantivTransactions.VantiveGridHeaders.paymentDepartmentType'
      ) as string,
      align: 'left',
      value: 'paymentDepartmentType',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'vantivTransactions.VantiveGridHeaders.ticketNumber'
      ) as string,
      align: 'left',
      value: 'ticketNumber',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'vantivTransactions.VantiveGridHeaders.referenceNumber'
      ) as string,
      align: 'left',
      value: 'referenceNumber',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'vantivTransactions.VantiveGridHeaders.status'
      ) as string,
      align: 'left',
      value: 'expressResponseMessage',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'vantivTransactions.VantiveGridHeaders.card'
      ) as string,
      align: 'left',
      value: 'cardLogo',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'vantivTransactions.VantiveGridHeaders.timeStamp'
      ) as string,
      align: 'left',
      value: 'timeStamp',
      fieldType: 'date',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'vantivTransactions.VantiveGridHeaders.amount'
      ) as string,
      align: 'left',
      value: 'transactionAmount',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'vantivTransactions.VantiveGridHeaders.action'
      ) as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

export function getPaymentAccountListHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      isNotDataProp: true,
      text: '',
      value: '',
      sortable: false,
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('arPaymentReport.headers.customerNumber') as string,
      value: 'customerNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('arPaymentReport.headers.customerName') as string,
      value: 'customerName',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('arPaymentReport.headers.date') as string,
      value: 'date',
      fieldType: 'date',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t('arPaymentReport.headers.status') as string,
      value: `status`,
      fieldType: 'html',
      filters: [
        (val) => {
          if (val === 'Approved') {
            return '<span class="green px-1 kbd">' + val + '</span>';
          } else {
            return '<span class="red px-1 kbd">' + val + '</span>';
          }
        },
      ],
    },
    // {
    //   align: 'left',
    //   sortable: false,
    //   text: vm.$parent.$t('arPaymentReport.headers.glStatus') as string,
    //   value: `glStatus`,
    //   fieldType: 'html',
    //   filters: [
    //     (val) => {
    //       if (val === 'True') {
    //         return '<span class="green px-1 kbd">Success</span>';
    //       } else {
    //         return '<span class="red px-1 kbd">Pending</span>';
    //       }
    //     },
    //   ],
    // },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('arPaymentReport.headers.totalAmount') as string,
      value: `amount`,
      fieldType: 'html',
      filters: [
        (val) => {
          if (val && val !== 'N/A' && !isNaN(val)) {
            return parseFloat(val).toFixed(2);
          } else {
            return '0.0';
          }
        },
      ],
    },
    {
      align: 'center',
      isNotDataProp: true,
      sortable: false,
      text: vm.$parent.$t('arPaymentReport.headers.action') as string,
    },
  ];
}

export function getPaymentAdHocHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      isNotDataProp: true,
      text: '',
      value: '',
      sortable: false,
    },
    {
      align: 'left',
      sortable: true,
      text: 'Receipt Number',
      value: 'receiptNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('arPaymentReport.headers.date') as string,
      value: 'date',
      fieldType: 'date',
    },
    // {
    //   align: 'left',
    //   sortable: false,
    //   text: vm.$parent.$t('arPaymentReport.headers.glStatus') as string,
    //   value: `glStatus`,
    //   fieldType: 'html',
    //   filters: [
    //     (val) => {
    //       if (val === 'True') {
    //         return '<span class="green px-1 kbd">Success</span>';
    //       } else {
    //         return '<span class="red px-1 kbd">Pending</span>';
    //       }
    //     },
    //   ],
    // },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('arPaymentReport.headers.totalAmount') as string,
      value: `amount`,
      fieldType: 'html',
      filters: [
        (val) => {
          if (val && val !== 'N/A' && !isNaN(val)) {
            return parseFloat(val).toFixed(2);
          } else {
            return '0.0';
          }
        },
      ],
    }
  ];
}


export function getPaymentDepositLogHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      isNotDataProp: true,
      text: '',
      value: '',
      sortable: false,
    },
    {
      align: 'left',
      sortable: true,
      text: 'Deposit Logs Id',
      value: 'depositLogsId',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('arPaymentReport.headers.date') as string,
      value: 'date',
      fieldType: 'date',
    },
    // {
    //   align: 'left',
    //   sortable: false,
    //   text: vm.$parent.$t('arPaymentReport.headers.glStatus') as string,
    //   value: `glStatus`,
    //   fieldType: 'html',
    //   filters: [
    //     (val) => {
    //       if (val === 'True') {
    //         return '<span class="green px-1 kbd">Success</span>';
    //       } else {
    //         return '<span class="red px-1 kbd">Pending</span>';
    //       }
    //     },
    //   ],
    // },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('arPaymentReport.headers.totalAmount') as string,
      value: `amount`,
      fieldType: 'html',
      filters: [
        (val) => {
          if (val && val !== 'N/A' && !isNaN(val)) {
            return parseFloat(val).toFixed(2);
          } else {
            return '0.0';
          }
        },
      ],
    }
  ];
}


export function getPaymentResponseHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      text: vm.$parent.$t(
        'arPaymentReport.paymentHeaders.approvalNumber'
      ) as string,
      value: 'approvalNumber',
      sortable: false,
    },
    {
      align: 'center',
      text: 'User',
      fieldType: 'template',
      sortable: false,
      template: (item) => {
        if (item) {
          if (item.updatedByEmail != undefined && item.updatedByEmail != ''
            && item.updatedByEmail != 'system') {
            return `<span>${item.updatedByEmail}</span>`;
          } else {
            return `<span>${item.createdByEmail != undefined ? item.createdByEmail : ''}</span>`;
          }
        } else {
          return ' ';
        }
      },
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.cardType') as string,
      value: 'cardLogo',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.lastFour') as string,
      value: 'cardLastFour',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t(
        'arPaymentReport.paymentHeaders.merchantId'
      ) as string,
      value: 'acceptorIdLastFour',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.date') as string,
      value: 'date',
      fieldType: 'date',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.method') as string,
      value: 'paymentMethod',
      fieldType: 'html',
      filters: [
        (val) => {
          if (val) {
            if (val == 'TriPOS')
              return '<span class= "info kbd px-1"> Terminal </span>';
            else
              return '<span class= "info kbd px-1">' + val + '</span>';
          } else {
            return '';
          }
        },
      ],
      sortable: false,
      // html: `paymentMethod?'<span class= "info kbd px-1">'+item.paymentMethod+'</span>':''`,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.type') as string,
      value: 'paymentType',
      fieldType: 'html',
      filters: [
        (val) => {
          if (val) {
            return '<span class= "warning kbd px-1">' + val + '</span>';
          } else {
            return '';
          }
        },
      ],
      sortable: false,
      // html: `paymentType?'<span class= "warning kbd px-1">'+item.paymentType+'</span>':''`,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.status') as string,
      value: 'status',
      fieldType: 'html',
      filters: [
        (val) => {
          if (val === 'Approved') {
            return '<span class= "green kbd px-1"> ' + val + '</span>';
          } else {
            return '<span class="red kbd px-1">' + val + '</kbd>';
          }
        },
      ],
      sortable: false,
    },
    {
      align: 'center',
      text: vm.$parent.$t('dealPaymentReport.gridHeaders.glStatus') as string,
      value: 'metaDataJson',
      fieldType: 'template',
      sortable: false,
      template: (val) => {
        if (val != undefined) {
          if (val.paymentType != 'Return' && val.glStatus)
            return `<span>Posted</span>`;
          else if (val.paymentType == 'Return' && val.refundGlStatus)
            return `<span>Posted</span>`;
          else
            return `<span>Pending</span>`;
        }
      },
    },
    {
      align: 'left',
      text: vm.$parent.$t(
        'arPaymentReport.paymentHeaders.paidAmount'
      ) as string,
      value: 'approvedAmount',
      // fieldType: 'template',
      // sortable: false,
      // template: (val) => {
      //   if (val.amountWithServiceCharges != undefined && val.amountWithServiceCharges != null)
      //     return `<span>${val.amountWithServiceCharges}</span>`;
      //   else
      //     return `<span>${val.approvedAmount}</span>`;
      // },
    },
    {
      align: 'left',
      text: 'Service Charges',
      // value: 'approvedAmount',
      fieldType: 'template',
      sortable: false,
      template: (val) => {
        if (val.paymentType != 'Return' && val.amountWithServiceCharges != undefined && val.amountWithServiceCharges != null && val.amountWithServiceCharges != '' && val.status == 'Approved') {
          var ServiceCharges = val.amountWithServiceCharges - val.approvedAmount;
          return `<span>${ServiceCharges.toFixed(2)}</span>`;
        }
        else if (val.paymentType == 'Return' && val.amountWithServiceCharges != undefined && val.amountWithServiceCharges != null && val.amountWithServiceCharges != '' && val.status == 'Approved') {
          var ServiceCharges = (val.amountWithServiceCharges * -1) - val.approvedAmount;
          return `<span>${ServiceCharges.toFixed(2)}</span>`;
        }
        else
          return `<span>0</span>`;
      },
    },
    {
      align: 'left',
      text: 'Bypass Reason',
      value: 'byPassReason',
      sortable: false,
      fieldType: 'template',
      template: (val) => {
        if (val.byPassReason) {
          return `<span>${val.byPassReason}</span>`;
        }
        else
          return `<span>N/A</span>`;
      },
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.action') as string,
      isNotDataProp: true,
      sortable: false,
    },
  ];
}


export function getArPaymentResponseHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      text: vm.$parent.$t(
        'arPaymentReport.paymentHeaders.approvalNumber'
      ) as string,
      value: 'approvalNumber',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.cardType') as string,
      value: 'cardLogo',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.lastFour') as string,
      value: 'cardLastFour',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t(
        'arPaymentReport.paymentHeaders.merchantId'
      ) as string,
      value: 'acceptorIdLastFour',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.date') as string,
      value: 'date',
      fieldType: 'date',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.method') as string,
      value: 'paymentMethod',
      fieldType: 'html',
      filters: [
        (val) => {
          if (val) {
            if (val == 'TriPOS')
              return '<span class= "info kbd px-1"> Terminal </span>';
            else
              return '<span class= "info kbd px-1">' + val + '</span>';

          } else {
            return '';
          }
        },
      ],
      sortable: false,
      // html: `paymentMethod?'<span class= "info kbd px-1">'+item.paymentMethod+'</span>':''`,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.type') as string,
      value: 'paymentType',
      fieldType: 'html',
      filters: [
        (val) => {
          if (val) {
            return '<span class= "warning kbd px-1">' + val + '</span>';
          } else {
            return '';
          }
        },
      ],
      sortable: false,
      // html: `paymentType?'<span class= "warning kbd px-1">'+item.paymentType+'</span>':''`,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.status') as string,
      value: 'status',
      fieldType: 'html',
      filters: [
        (val) => {
          if (val === 'Approved') {
            return '<span class= "green kbd px-1"> ' + val + '</span>';
          } else {
            return '<span class="red kbd px-1">' + val + '</kbd>';
          }
        },
      ],
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t(
        'arPaymentReport.paymentHeaders.paidAmount'
      ) as string,
      value: 'approvedAmount',
      // fieldType: 'template',
      // sortable: false,
      // template: (val) => {
      //   if (val.amountWithServiceCharges != undefined && val.amountWithServiceCharges != null)
      //     return `<span>${val.amountWithServiceCharges}</span>`;
      //   else
      //     return `<span>${val.approvedAmount}</span>`;
      // },
    },
    {
      align: 'left',
      text: 'Service Charges',
      // value: 'approvedAmount',
      fieldType: 'template',
      value: 'approvedAmount',
      sortable: false,
      template: (val) => {
        if (val.paymentType != 'Return' && val.amountWithServiceCharges != undefined && val.amountWithServiceCharges != null && val.amountWithServiceCharges != '' && val.status == 'Approved') {
          var ServiceCharges = val.amountWithServiceCharges - val.approvedAmount;
          return `<span>${ServiceCharges.toFixed(2)}</span>`;
        }
        else if (val.paymentType == 'Return' && val.amountWithServiceCharges != undefined && val.amountWithServiceCharges != null && val.amountWithServiceCharges != '' && val.status == 'Approved') {
          var ServiceCharges = (val.amountWithServiceCharges * -1) - val.approvedAmount;
          return `<span>${ServiceCharges.toFixed(2)}</span>`;
        }
        else
          return `<span>0</span>`;
      },
    },
    // {
    //   align: 'left',
    //   text: 'Bypass Reason',
    //   value: 'byPassReason',
    //   sortable: false,
    //   fieldType: 'template',
    //   template: (val) => {
    //     if ( val.byPassReason) {
    //       return `<span>${val.byPassReason}</span>`;
    //     }
    //     else
    //       return `<span>N/A</span>`;
    //   },
    // },
    {
      align: 'center',
      text: vm.$parent.$t('dealPaymentReport.gridHeaders.glStatus') as string,
      value: 'metaDataJson',
      fieldType: 'template',
      sortable: false,
      template: (val) => {
        if (val != undefined) {
          if (val.paymentType != 'Return' && val.glStatus)
            return `<span>Posted</span>`;
          else if (val.paymentType == 'Return' && val.refundGlStatus)
            return `<span>Posted</span>`;
          else
            return `<span>Pending</span>`;
        }
      },
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.action') as string,
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

export function getDealPaymentResponseHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      text: vm.$parent.$t(
        'arPaymentReport.paymentHeaders.approvalNumber'
      ) as string,
      value: 'approvalNumber',
      sortable: false,
    },
    {
      align: 'center',
      text: 'User',
      fieldType: 'template',
      sortable: false,
      template: (item) => {
        if (item) {
          if (item.updatedByEmail != undefined && item.updatedByEmail != ''
            && item.updatedByEmail != 'system') {
            return `<span>${item.updatedByEmail}</span>`;
          } else {
            return `<span>${item.createdByEmail != undefined ? item.createdByEmail : ''}</span>`;
          }
        } else {
          return ' ';
        }
      },
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.cardType') as string,
      value: 'cardLogo',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.lastFour') as string,
      value: 'cardLastFour',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t(
        'arPaymentReport.paymentHeaders.merchantId'
      ) as string,
      value: 'acceptorIdLastFour',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.date') as string,
      value: 'date',
      fieldType: 'date',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.method') as string,
      value: 'paymentMethod',
      fieldType: 'html',
      filters: [
        (val) => {
          if (val) {
            if (val == 'TriPOS')
              return '<span class= "info kbd px-1"> Terminal </span>';
            else
              return '<span class= "info kbd px-1">' + val + '</span>';

          } else {
            return '';
          }
        },
      ],
      sortable: false,
      // html: `paymentMethod?'<span class= "info kbd px-1">'+item.paymentMethod+'</span>':''`,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.type') as string,
      value: 'paymentType',
      fieldType: 'html',
      filters: [
        (val) => {
          if (val) {
            return '<span class= "warning kbd px-1">' + val + '</span>';
          } else {
            return '';
          }
        },
      ],
      sortable: false,
      // html: `paymentType?'<span class= "warning kbd px-1">'+item.paymentType+'</span>':''`,
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.status') as string,
      value: 'status',
      fieldType: 'html',
      filters: [
        (val) => {
          if (val === 'Approved') {
            return '<span class= "green kbd px-1"> ' + val + '</span>';
          } else {
            return '<span class="red kbd px-1">' + val + '</kbd>';
          }
        },
      ],
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t(
        'arPaymentReport.paymentHeaders.paidAmount'
      ) as string,
      value: 'approvedAmount',
      // fieldType: 'template',
      // sortable: false,
      // template: (val) => {
      //   if (val.amountWithServiceCharges != undefined && val.amountWithServiceCharges != null)
      //     return `<span>${val.amountWithServiceCharges}</span>`;
      //   else
      //     return `<span>${val.approvedAmount}</span>`;
      // },
    },
    {
      align: 'left',
      text: 'Service Charges',
      // value: 'approvedAmount',
      fieldType: 'template',
      sortable: false,
      template: (val) => {
        if (val.paymentType != 'Return' && val.amountWithServiceCharges != undefined && val.amountWithServiceCharges != null && val.amountWithServiceCharges != '' && val.status == 'Approved') {
          var ServiceCharges = val.amountWithServiceCharges - val.approvedAmount;
          return `<span>${ServiceCharges.toFixed(2)}</span>`;
        }
        else if (val.paymentType == 'Return' && val.amountWithServiceCharges != undefined && val.amountWithServiceCharges != null && val.amountWithServiceCharges != '' && val.status == 'Approved') {
          var ServiceCharges = (val.amountWithServiceCharges * -1) - val.approvedAmount;
          return `<span>${ServiceCharges.toFixed(2)}</span>`;
        }
        else
          return `<span>0</span>`;
      },
    },
    {
      align: 'left',
      text: 'Bypass Reason',
      value: 'byPassReason',
      sortable: false,
      fieldType: 'template',
      template: (val) => {
        if (val.byPassReason) {
          return `<span>${val.byPassReason}</span>`;
        }
        else
          return `<span>N/A</span>`;
      },
    },
    {
      align: 'center',
      text: vm.$parent.$t('dealPaymentReport.gridHeaders.glStatus') as string,
      value: 'metaDataJson',
      fieldType: 'template',
      sortable: false,
      template: (val) => {
        if (val != undefined) {
          if (val.paymentType != 'Return' && val.glStatus)
            return `<span>Posted</span>`;
          else if (val.paymentType == 'Return' && val.refundGlStatus)
            return `<span>Posted</span>`;
          else
            return `<span>Pending</span>`;
        }
      },
    },
    {
      align: 'left',
      text: vm.$parent.$t('arPaymentReport.paymentHeaders.action') as string,
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

export function getCustomerChargeTransactionHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      text: vm.$parent.$t(
        'arPaymentReport.customerChargeHeaders.transactionNumber'
      ) as string,
      value: 'transNumber',
    },
    {
      align: 'left',
      text: vm.$parent.$t(
        'arPaymentReport.customerChargeHeaders.documentNumber'
      ) as string,
      value: 'documentNumber',
    },
  ];
}

export function getReportROHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      isNotDataProp: true,
      text: '',
      value: '',
      sortable: false,
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'repairOrderPaymentReport.roPaymentReportGrid.status'
      ) as string,
      value: 'roStatus',
      filters: [
        (val, item) => {
          if (val === 'CL') {
            return vm.$parent.$t(
              'repairOrderPaymentReport.roPaymentReportGrid.closed'
            ) as string;
          } else {
            return vm.$parent.$t(
              'repairOrderPaymentReport.roPaymentReportGrid.open'
            ) as string;
          }
        },
      ],
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'repairOrderPaymentReport.roPaymentReportGrid.lastModified'
      ) as string,
      value: 'lastModified',
      filters: [
        (v) => {
          if (v && v !== '0001-01-01T00:00:00.0000000') {
            return this.$moment(v).format('lll');
          } else {
            return 'N/A';
          }
        },
      ],
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'repairOrderPaymentReport.roPaymentReportGrid.ro'
      ) as string,
      value: 'repairOrderNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'repairOrderPaymentReport.roPaymentReportGrid.customerName'
      ) as string,
      value: 'customerName',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'repairOrderPaymentReport.roPaymentReportGrid.advisor'
      ) as string,
      value: 'advisorName',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'repairOrderPaymentReport.roPaymentReportGrid.date'
      ) as string,
      value: 'date',
      fieldType: 'date',
    },
    {
      align: 'center',
      text: vm.$parent.$t(
        'repairOrderPaymentReport.roPaymentReportGrid.status2'
      ) as string,
      value: 'status',
      fieldType: 'template',
      template: (item) => {
        // tslint:disable-next-line:max-line-length
        return `<v-chip small text-color="white" :color="'${item.status === 'Approved' ? 'success' : 'error'
          }'">${item.status}</v-chip>`;
      },
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'repairOrderPaymentReport.roPaymentReportGrid.totalAmount'
      ) as string,
      fieldType: 'html',
      filters: [
        (val, item) => {
          if (val) {
            return item.amount.toFixed(2);
          } else {
            return '0.0';
          }
        },
      ],
      value: `amount`,
    },
    // , {
    //     align: 'left',
    //     text: vm.$parent.$t('repairOrderPaymentReport.roPaymentReportGrid.action') as string,
    //     isNotDataProp: true,
    //     sortable: false,
    // },
  ];
}
